import { create } from 'zustand'

/**
 * Creates a zustand store for managing selected node key state.
 */
export type NodeKeySelectionStoreType<T = string> = {
    selectedKey: T | null
    setSelectedKey: (key: T | null) => void
}

export const useNodeKeySelectionStore = create<NodeKeySelectionStoreType>()(
    (set) => ({
        selectedKey: null,
        setSelectedKey: (key) => set({ selectedKey: key }),
    })
)

/** Zustand selector for getting the selected key. */
export const useSelectedKey = () =>
    useNodeKeySelectionStore((state) => state.selectedKey)

/** Zustand selector for getting the setter for selected key. */
export const useSetSelectedKey = (): ((key: string | null) => void) =>
    useNodeKeySelectionStore((state) => state.setSelectedKey)

export const useNodeKeySelectionActions = () =>
    useNodeKeySelectionStore((state) => ({
        selectedKey: state.selectedKey,
        setSelectedKey: state.setSelectedKey,
    }))
